import Rand from 'rand-seed';
import { WORDS as WORDS_3 } from './wordlist3';
import { WORDS as WORDS_4 } from './wordlist4';

const wordListCookieValue = document.cookie
  .split('; ')
  .find(row => row.startsWith('wordLists='))
  ?.split('=')[1] ?? null;
const wordListsToUse = wordListCookieValue ? wordListCookieValue.split(',') : ['3', '4'];
const wordLists = [];
if(wordListsToUse.includes('all')) {
  wordLists.push(...WORDS_3, ...WORDS_4);
} else {
  if(wordListsToUse.includes('3')) {
    wordLists.push(...WORDS_3);
  }
  if(wordListsToUse.includes('4')) {
    wordLists.push(...WORDS_4);
  }
}

//randomize the wordlist
const r = new Rand('SightWordle');
export const WORDS =  [
    ...wordLists
].sort(() => 0.5 - r.next());